import { render, staticRenderFns } from "./ThreadChat.vue?vue&type=template&id=66744340&scoped=true&"
import script from "./ThreadChat.vue?vue&type=script&lang=js&"
export * from "./ThreadChat.vue?vue&type=script&lang=js&"
import style0 from "./ThreadChat.vue?vue&type=style&index=0&id=66744340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66744340",
  null
  
)

export default component.exports